__turbopack_context__.v({
  "verified": "VerifiedPill-module-scss-module__56V3Oq__verified",
  "verifiedText": "VerifiedPill-module-scss-module__56V3Oq__verifiedText",
});
